import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import Button from '../common/button/Button';
import Modal from '../common/modal/Modal';
import OutlineButton from '../common/button/OutlineButton';
import TextButton from '../common/button/TextButton';
import shareBtnImg from './ShareBTN.png';
import addToHomeBtnImg from './AddToHomeBTN.png';
import leggTilBtnImg from './LeggTilBTN.png';
import { ReactComponent as CrossCircle } from './cross-circle.svg';
import './AddToHomescreen.scss';

const AddToHomescreen = (): JSX.Element => {
  const [isVisible, setIsVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [rejectCount, setRejectCount] = useState(0);
  const rejectCookieKey = 'bymelding_portal_reject_cookie_key';

  const isIOS = (): boolean | number => {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
      return true;
    }
    return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
  };

  const isIpadOS = (): boolean | number => {
    return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
  };

  // eslint-disable-next-line dot-notation
  const isInStandaloneMode = (): unknown => 'standalone' in window.navigator && window.navigator['standalone'];

  const getRejectedCount = async (): Promise<number> => {
    const rejectedCount = await Cookies.get(rejectCookieKey);
    if (!rejectedCount) return 0;
    const num = Number.parseInt(rejectedCount, 10);
    setRejectCount(num);
    return num;
  };

  const reject = (): void => {
    setIsVisible(false);
    Cookies.set(rejectCookieKey, (rejectCount + 1).toString(), { expires: 365 });
  };

  useEffect(() => {
    const init = async (): Promise<void> => {
      const rejectedCount = await getRejectedCount();
      if (rejectedCount < 3 && (isIOS() || isIpadOS()) && !isInStandaloneMode()) {
        setIsVisible(true);
      }
    };
    init();
  }, []);

  return isVisible ? (
    <div className={`add-to-homescreen-container  ${expanded ? 'hidden' : 'add-to-homescreen-not-expanded'}`}>
      <div className="flex flex-no-wrap px-4 fixed w-full bottom-0 left-0 bg-grey-light">
        <TextButton
          className="flex-grow p-2"
          type="button"
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          Legg til snarvei på hjem-skjermen
        </TextButton>
        <TextButton className="p-2" color="" type="button" onClick={reject}>
          <CrossCircle />
        </TextButton>
      </div>
      <Modal toggle={() => setExpanded(!expanded)} isOpen={expanded} preventScroll>
        <ol className="add-to-homescreen-content flex flex-col ">
          <li>
            <p>
              Klikk på &quot;del&quot; knappen
              <div>
                <img alt="Del-knapp" src={shareBtnImg} />
              </div>
            </p>
          </li>
          <li>
            <p>
              Velg &quot;Legg til på Hjem-skjermen&quot;
              <div>
                <img alt="Dele-meny" src={addToHomeBtnImg} />
              </div>
            </p>
          </li>
          <li>
            <p>
              Klikk på &quot;Legg til&quot;
              <div>
                <img alt="Legg til knapp" src={leggTilBtnImg} />
              </div>
            </p>
          </li>
        </ol>
        <div className="flex justify-end mb-4 space-x-3 p-2">
          <OutlineButton
            type="button"
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            Lukk
          </OutlineButton>
          <Button className="add-to-homescreen-close-btn" type="button" onClick={reject}>
            Avvis
          </Button>
        </div>
      </Modal>
    </div>
  ) : (
    <div />
  );
};

export default AddToHomescreen;
